import TableList from "@components/templates/tablelist";
import {
    HttpReimbursementList,
    HttplogOrderAction,
    HttpbatchSubmitBill,
    HttpCountReimbursementList
} from "@/service/reimbursement";
// 索赔单
import mixin from "./mixin";
import {
    mapGetters
} from 'vuex';
import compDetail from './update';
import exportModal from './exportModal'
export default {
    mixins: [TableList, mixin],
    components: {
        compDetail
    },
    data() {
        return {
            isMixin: true,
            Tools: {
                show: true
            },
            Tabs: {
                show: true
            },

            formData: {
                search: {
                    EQ_status: null
                },
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            sum: {
                draft: 0,
                toAduit: 0,
                refuse:0,
                processing:0,
                complete: 0,
                compensation:0,
                cancel:0,
            },
            Plugins: {
                show: true
            },
            searchOptions: {
                reimbursementReason: []
            },
        };
    },
    created() {
       /*  this.getSum(); */
    },
    methods: {
        ajaxRequest: HttpReimbursementList,
        interceptResponse(){
            this.getSum();
        },
        interceptRequest(params) {
            const { CN_propsCarrier,CN_propsTracking,CN_detailTracking,CN_warehouseCode,CN_reimbursementNo } = params.search;
            let propsCarrier,propsTracking,detailTracking,warehouseCode,IN_reimbursementNo;
            if(CN_propsCarrier){
                propsCarrier = "\"saleCarrier\":"+"\""+CN_propsCarrier+"\"";
            }
            if(CN_propsTracking){
                propsTracking = "\"trackingNo\":"+"\""+params.search.CN_propsTracking+"\"";
            }
            if(CN_detailTracking){
                detailTracking = "\"trackingNo\":"+"\""+params.search.CN_detailTracking+"\"";
            }
            if(CN_warehouseCode){
                warehouseCode = "\"warehouseCode\":"+"\""+params.search.CN_warehouseCode+"\"";
            }
            if(CN_reimbursementNo){
                IN_reimbursementNo = params.search.CN_reimbursementNo.replace(/\n/g,",");
            }
            params.propsSku = params.search.IN_propsSku
            params.propsCarrier = propsCarrier
            params.propsTracking = propsTracking
            params.detailTracking = detailTracking
            params.warehouseCode = warehouseCode
            params.search.IN_reimbursementNo = IN_reimbursementNo;

            delete params.search.CN_propsCarrier;
            delete params.search.IN_propsSku;
            delete params.search.CN_propsTracking;
            delete params.search.CN_detailTracking;
            delete params.search.CN_warehouseCode;
            delete params.search.CN_reimbursementNo;
            return this.handleParams(params);
        },
        handleParams(params){
            /* if(params.search.CN_propsCarrier){
                params.propsCarrier = "\"saleCarrier\":"+"\""+params.search.CN_propsCarrier+"\"";
                this.formData.propsCarrier = "\"saleCarrier\":"+"\""+params.search.CN_propsCarrier+"\"";
                params.search.CN_propsCarrier = "";
                this.formData.search.CN_propsCarrier = "";
            }else{
                params.propsCarrier = "";
                this.formData.propsCarrier = "";
            }
            if(params.search.CN_propsTracking){
                params.propsTracking = "\"trackingNo\":"+"\""+params.search.CN_propsTracking+"\"";
                this.formData.propsTracking = "\"trackingNo\":"+"\""+params.search.CN_propsTracking+"\"";
                params.search.CN_propsTracking = "";
                this.formData.search.CN_propsTracking = "";
            }else{
                params.propsTracking = "";
                this.formData.propsTracking = "";
            }
            if(params.search.CN_detailTracking){
                params.detailTracking = "\"trackingNo\":"+"\""+params.search.CN_detailTracking+"\"";
                this.formData.detailTracking = "\"trackingNo\":"+"\""+params.search.CN_detailTracking+"\"";
                params.search.CN_detailTracking = "";
                this.formData.search.CN_detailTracking = "";
            }else{
                params.detailTracking = "";
                this.formData.detailTracking = "";
            }
            if(params.search.CN_warehouseCode){
                params.warehouseCode = "\"warehouseCode\":"+"\""+params.search.CN_warehouseCode+"\"";
                this.formData.warehouseCode = "\"warehouseCode\":"+"\""+params.search.CN_warehouseCode+"\"";
                params.search.CN_warehouseCode = "";
                this.formData.search.CN_warehouseCode = "";
            }else{
                params.warehouseCode = "";
                this.formData.warehouseCode = "";
            }
            if(params.search.CN_reimbursementNo){
                params.search.IN_reimbursementNo = params.search.CN_reimbursementNo.replace(/\n/g,",");
            }
            delete params.search.CN_reimbursementNo; */
            return params
        },
        getSum(){
            HttpCountReimbursementList({
                contextId: global.SYSID,
            })
            .then(res => {
                this.sum.draft = res.data.draft;
                this.sum.toAduit = res.data.toAduit;
                this.sum.refuse = res.data.refuse;
                this.sum.processing = res.data.processing;
                this.sum.complete = res.data.complete;
                this.sum.compensation = res.data.compensation;
                this.sum.cancel = res.data.cancel;
            });
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'reimbursementUpdate',
                        params: {
                            type: "add"
                        },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'reimbursementUpdate',
                        params: {
                            type: "edit"
                        },
                        query: {
                            id: params
                        },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '详情',
                        show: true,
                        width: 1200,
                        component: "compDetail",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false,
                        /* on: {
                            "on-close": row => {
                                this.modalProps.show = false;
                            }
                        } */
                    }
                    break;
                case 'queryBlank':
                    window.open(this.$router.resolve({
                        name: "reimbursementUpdate",
                        params: {
                            type: 'query'
                        },
                        query: {
                            id: params
                        },
                    }).href, '_blank');
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "取消",
                        width: 460,
                        showDesc: false,
                        params: {
                            headId: params,
                            opAction: 7
                        },
                        ajaxRequest: HttplogOrderAction,
                        formdata: [{
                            tag: "vTextarea",
                            key: "opData",
                            labelWidth: 'auto',
                            span: 24,
                            label: "取消原因"
                        }]
                    };
                    break;
                case "submit":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: "提交审核",
                        params: {
                            headId: params,
                            opAction: 2
                        },
                        ajaxRequest: HttplogOrderAction,

                    };
                    break;
                case "cancelAudit":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: "撤销审核",
                        params: {
                            headId: params,
                            opAction: 3
                        },
                        ajaxRequest: HttplogOrderAction,

                    };
                    break;
                case "batchExport":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: "导入",
                        width: 550,
                        component: exportModal,
                        showFooter: false,
                        showDesc: false,
                        
                    };
                    break;
                case "batchSubmit":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "提交",
                        params: { ids: params },
                        ajaxRequest: HttpbatchSubmitBill,
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/reimbursement/Reimbursement/export',this.interceptRequest(JSON.parse(JSON.stringify(this.formData))), { executor: 'request', download: true })
                    break;
            }
        },
        getOperateNodeMap(row) {
            const {
                id,
                status: status
            } = row
            return [{
                label: '查看详情',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '提交审核',
                show: status == 1 || status == 3,
                params: id,
                operate: 'submit'
            }, {
                label: '撤销审核',
                show: status == 2,
                params: id,
                operate: 'cancelAudit'
            }, {
                label: '编辑',
                show: status == 1 || status == 3,
                params: id,
                operate: 'edit'
            }, {
                label: '取消',
                show: status == 1 || status == 2 || status == 3,
                params: id,
                operate: 'cancel'
            }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList','getFilterDisabledWarehouse']),
        TabsData() {
            return [{
                name: "所有",
                key: 'EQ_status',
                value: null
            }, {
                name: "草稿" + '（' + this.sum.draft + '）',
                key: 'EQ_status',
                value: 1
            }, {
                name: "待审核" + '（' + this.sum.toAduit + '）',
                key: 'EQ_status',
                value: 2
            }, {
                name: "审核拒回" + '（' + this.sum.refuse + '）',
                key: 'EQ_status',
                value: 3
            }, {
                name: "处理中" + '（' + this.sum.processing + '）',
                key: 'EQ_status',
                value: 4
            }, {
                name: "平台完成"+ '（' + this.sum.complete + '）',
                key: 'EQ_status',
                value: 5
            }, {
                name: "赔付完成"+ '（' + this.sum.compensation + '）',
                key: 'EQ_status',
                value: 7
            }, {
                name: "已取消"+ '（' + this.sum.cancel + '）',
                key: 'EQ_status',
                value: 6
            }]
        },
        ToolsData() {
            return [{
                name: "添加",
                operate: "add",
                theme: "primary",
            }, {
                name: "导出",
                operate: "export",
                theme: "info",
            },
            {
                name: "批量导入",
                operate: "batchExport",
                more: true,
            }, 
            {
                name: "批量提交",
                operate: "batchSubmit",
                more: true,
                batch:true
            }, ]
        },
        SearchsData() {
            let that = this
            let widthStyle = 'width: 160px;'
            return [{
                    label: "索赔单号",
                    key: 'CN_reimbursementNo',
                    show: true,
                    tag: 'vTextarea',
                    class:"inboundtext",
                    props:{
                        placeholder: this.$t('fbb.inbound.input_more_line', { defaultValue: "输入多个，一行一个" }),
                        rows:"1",
                    }
                },
                {
                    label: '项目',
                    key: 'EQ_lineId',
                    tag: 'vSelect',
                    show: true,
                    options: this.getProductList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "状态",
                    tag: 'vSelect',
                    key: 'EQ_status',
                    show: true,
                    options: this.statusList
                },
                {
                    label: "来源单号",
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    style: widthStyle,
                },
                {
                    label: "索赔类型",
                    tag: 'vSelect',
                    key: 'EQ_reimbursementType',
                    style: widthStyle,
                    options: this.reimbursementTypeList,
                   /*  hideSearchTip: true,
                    on: {
                        'on-change': function (value) {
                            that.searchOptions.reimbursementReason = that.reimbursementTypeList.filter(item => {
                                return item.value == value
                            })[0].child
                        }
                    }, */
                },
                {
                    label: "索赔原因",
                    tag: 'vSelect',
                    key: 'EQ_reimbursementReason',
                    style: widthStyle,
                    /* hideSearchTip: true,     */             
                    options: this.reimbursementReasonList
                },
                {
                    label: "发货Carrier",
                    tag: 'vInput',
                    key: 'CN_propsCarrier',
                    style: widthStyle,
                },
                {
                    label: "发货Tracking",
                    tag: 'vInput',
                    key: 'CN_propsTracking',
                    style: widthStyle,
                },
                 {
                    label: "尾程费用tracking",
                    tag: 'vInput',
                    key: 'CN_detailTracking',
                    style: widthStyle,
                },
                {
                    label: "仓库",
                    tag: 'vSelect',
                    key: 'CN_warehouseCode',
                    style: widthStyle,
                    options: this.getFilterDisabledWarehouse.map(item => {
                        return {
                            label: item.label,
                            value: item.attach.code
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "SKU",
                    tag: 'vInput',
                    key: 'IN_propsSku',
                    style: widthStyle,
                },
                {
                    label: "caseId",
                    tag: 'vInput',
                    key: 'EQ_caseId',
                    style: widthStyle,
                },
                {
                    label: "提交人",
                    tag: 'vInput',
                    key: 'EQ_createdName',
                    style: widthStyle,
                },
                {
                    label: "提交时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    style: widthStyle,
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: "更新时间",
                    tag: 'vDatepicker',
                    style: widthStyle,
                    key: 'BT_updatedAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                },

            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '操作',
                    maxWidth: 70,
                    render: this.getOperateNodes
                },
                {
                    title: '索赔单号/来源单号',
                    width: 110,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>
                                    {row.reimbursementNo || '--'}
                                </a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}>
                                    <vIcon class="margin-left-10 font-14" type="ios-browsers-outline" />
                                </a>
                                <br />
                                {row.sourceNo || '--'}
                            </div>
                        )
                    }
                },
                {
                    title: '项目',
                    maxWidth: 90,
                    key: 'lineName',
                    render: (h, { row }) => this.findRenderLabel(this.getProductList, row.lineId)
                },
                {
                    title: '状态',
                    key: 'status',
                    width: 70,
                    render: (h, { row }) => {
                        const status = row.status;
                        const { theme = 'default', label } = this.statusList.find(item => {
                            return item.value == status;
                        }) || {};
                        return (
                            <vButton ghost theme={theme} size="small" class="cursor-not width-60">
                                {label}
                            </vButton>
                        )
                    }
                },
                {
                    title: '索赔类型/索赔原因',
                    key: 'reimbursementType',
                    width: 120,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>
                                    {this.findRenderLabel(this.reimbursementTypeList, row.reimbursementType) || '--'}
                                </div>
                                <div>
                                    {this.findRenderLabel(
                                        (this.reimbursementTypeList.filter(item => item.value == row.reimbursementType)[0] || {}).child,
                                        row.reimbursementReason
                                    ) || '--'}
                                </div>
                            </div>
                        )
                    }
                },
                {
                    title: '索赔金额',
                    width: 60,
                    render: (h, { row }) => {
                        return <div>{row.reimbursementAmount || '--'}</div>
                    }
                },
                {
                    title: '实际赔偿金额（USD）',
                    width: 100,
                    render: (h, { row }) => {
                        return <div>{row.actualAmount || '--'}</div>
                    }
                },
                {
                    title: '实际发票金额',
                    width: 60,
                    render: (h, { row }) => {
                        return <div>{row.actualInvoiceAmount || '--'}</div>
                    }
                },
                {
                    title: 'caseId',
                    width: 80,
                    render: (h, { row }) => {
                        return <div>{row.caseId || '--'}</div>
                    }
                },
                {
                    title: 'TrackingNo',
                    width: 100,
                    render: (h, { row }) => {
                        return <div>{row.trackingNo || '--'}</div>
                    }
                },
                {
                    title: '物流服务',
                    width:  140,
                    render: (h, { row }) => {
                        const props = row.props ? JSON.parse(row.props) : {};
                        return <div>{props.logisticsServiceCode || '--'}</div>;
                    }
                },
                {
                    title: '提交人',
                    key: 'createdName',
                    maxWidth: 80,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{row.createdName || '--'}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '提交时间/更新时间',
                    width: 110,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{row.createdAt || '--'}</div>
                                <div>{row.updatedAt || '--'}</div>
                            </div>
                        )
                    }
                }
            ];
        }
    },
};
